import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
import { getCompany } from "../../Redux/Actions/company";
import Loader from "react-loader-spinner";
import { multiDownloadDocument } from "../../Redux/Actions/jobs";
import LoadingButton from "../../utils/loadingButton";
const DisplayConatiner = ({ label, value }) => (
  <div
    className="form-group fv-plugins-icon-container"
    style={{
      marginBottom: "10px",
      paddingBottom: "5px",
      borderBottom: "1px solid #f1f5fa",
    }}
  >
    <span className="text-muted">{label} : </span>
    {value}
  </div>
);

function CompanyInfo() {
  const { id } = useParams();
  const [companyDetail, setCompanyDetail] = useState({});
  const [pageLoading, setPageLoading] = useState(false);
  const [downloadButtonloading, setDownloadButtonLoading] = useState(false);

  const handleDownload = async (documentIds) => {
    const payload = documentIds?.map(itr => ({ userId:2,documentId: itr.documentId }));
    setDownloadButtonLoading(true);
    try {
      const response = await multiDownloadDocument(payload);
      let binary_string = window.atob(response.data.content);
      let len = binary_string.length;
      let bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      let blob = new Blob([bytes], { type: response.data.contentType });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Company Document";
      link.click();
    } catch (error) {
      console.log("handleDownloadDocument", error);
    }
    setDownloadButtonLoading(false);
  };
  
  const displayData = [
    { label: "Company name", value: companyDetail?.companyName },
    { label: "Company Email", value: companyDetail?.companyEmail },
    { label: "Contact person name", value: companyDetail?.contactPersonName },
    { label: "contact Person Email", value: companyDetail?.contactPersonEmail },
    { label: "company Registration ExpiryDate", value: companyDetail?.companyRegistrationExpiryDate },
    { label: "company Registration Vat Number", value: companyDetail?.companyRegistrationVatNumber }
  ];

  useEffect(() => {
    if (id) {
      getCompanybByIdApi(id);
    }
  }, [id]);

  const getCompanybByIdApi = async (id) => {
    setPageLoading(true);
    try {
      const res = await apiWrapWithErrorWithData(getCompany(id));
      const response = res.data;
      setCompanyDetail(response?.data);
    } catch (error) {
      console.log("getCorporateJobByIdApi:", error);
    }
    setPageLoading(false);
  };
  return (
    <div className="container-fluid">
      <h4 className="py-3">Company Details</h4>
      {pageLoading ? (
        <div className="d-flex align-items-center justify-content-center h-75vh">
          <Loader
            type="ThreeDots"
            color="#2d207d"
            height={40}
            width={40}
            style={{ textAlign: "center" }}
          />
        </div>
      ) : (
        <div className="row col-lg-12">
          <div className="card card-custom card-stretch gutter-b p-2">
            <div className="p-2">
              {displayData.map(({ label, value }) => (
                <DisplayConatiner key={label} label={label} value={value} />
              ))}

              <div>
                {companyDetail?.companyDocument?.length ? (
                  <div
                    className="form-group fv-plugins-icon-container"
                    style={{
                      marginBottom: "10px",
                      paddingBottom: "5px",
                      borderBottom: "1px solid #f1f5fa",
                    }}
                  >
                    <span className="text-muted">Company Document : </span>
                    <LoadingButton
                      style={{ margin: "1rem" }}
                      isLoading={downloadButtonloading}
                      onChange={() => handleDownload(companyDetail.companyDocument)}
                    >
                      Download document{" "}
                    </LoadingButton>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>

  )
}
export default CompanyInfo